// import logo from './logo.svg';
import '../../app.scss';
import React, { useState, useEffect } from "react";

import Banner from './main-banner/Banner.js';
import Gateawayfeature from './gateway/Gateawayfeature.js';
import Faqs from './Faqs/Faqs.js';
import Evolve from './Evolvetomi/Evolve.js';
import Footer from './footer/Footer.js';
import Header from './Header/Header.js';









function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    document.title = "Web3 Ecosystem- tomi ";
  
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "The Complete Web3 Ecosystem: connect, transact, and manage your digital identity with complete privacy and control  - tomi");
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = "The Complete Web3 Ecosystem: connect, transact, and manage your digital identity with complete privacy and control  - tomi";
      document.head.appendChild(meta);
    }
  }, []);


  return (
    <>

      <Banner />
      <Gateawayfeature />
      <Faqs />
      <Evolve />
      <Footer/>
    </>
  );
}

export default Landing;